import { createApp } from 'vue';
import Gc10D1PTable from '../../gc10-report/D1PTable.vue'

// Allow multiple Vue apps in the same page
const appElements = document.querySelectorAll('.vue-gc10-render-d1')

Array.from(appElements).forEach(element => {
  createApp(Gc10D1PTable).mount(element);
});